import { render, staticRenderFns } from "./SurveyIntro.vue?vue&type=template&id=4a20a019&"
import script from "./SurveyIntro.vue?vue&type=script&lang=js&"
export * from "./SurveyIntro.vue?vue&type=script&lang=js&"
import style0 from "./SurveyIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports